import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Label1 from "../Label1";

const CustomFileInputWrapper = styled.input`
    width: 104px;
    height: 32px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    color: transparent;
    
    background: #FFFFFF;
    /* default/gray/300 */
    border: 1px solid #E2E8F0;
    box-sizing: border-box;
    /* shadow-base */
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    
    /* text-base/Regular */
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    
    /* default/gray/900 */
    //color: var(--color-gray-900);
    
    &::-webkit-file-upload-button {
      visibility: hidden;
    }
    &::before {
      display: flex;
      justify-content: center;
      align-items: center;
      
      height: 100%;
  
      color: var(--color-gray-900);
      content: ${props => (props.label ? `'${props.label}'` : "'Choose File'")};
      
      font-family: Metropolis;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      
      cursor: pointer;
    }
    &:hover::before {
      //background-color: var(--gray-secondary);
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
    &:active::before {
      background-color: rgba(118,118,117,0.5);
      background-size: 100%;
      transition: background 0s;
    }
    &:focus::before {
      outline: none
    }
    &:focus {
      outline: none
    }
    &:active {
      outline: 0;
      &::before {
    }
}`;

const InputWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    
    * {
      margin-right: 8px;
    }
`;

const UploadedBadge = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: var(--company-success);  
    border: 1px var(--color-green-500);
    opacity:  ${({visible}) => (visible ? 1 : 0)};
`;

function ActionButton3FileInput({onChange, label, uploaded}) {
    const [isUploaded, setUploaded] = useState(false);
    const [fileName, setFileName] = useState('Hello');
    const fileRef = useRef();

    const handleOnChange = e => {
        setUploaded(true);
        onChange(e);

        const name = fileRef?.current?.files[0]?.name;
        setFileName(name);
    };

    return (
        <InputWrapper>
            <CustomFileInputWrapper ref={fileRef} type="file" name={fileName} onChange={handleOnChange} label={label} isUploaded={isUploaded}/>
            {/*<Label1>{fileName}</Label1>*/}
            <UploadedBadge visible={isUploaded}/>
        </InputWrapper>
    );
}

ActionButton3FileInput.propTypes = {};
ActionButton3FileInput.defaultProps = {};

export default ActionButton3FileInput;
